module.exports = __webpack_public_path__ + "img/sh_text_only.813d1c49.svg";